
























import { Vue, Component, Lifecycle } from "av-ts";
import { IConsentForm, IOfferingUser, IOffering } from "../../interfaces/models";

import { addEventsToQueue } from "../../util";

import ConsentForm from "./ConsentForm.vue";

import UserService from "../../services/UserService";
import Fetcher from "../../services/Fetcher";

@Component({
    components: {
        ConsentForm
    }
})
export default class ConsentFormWrapper extends Vue {
    pOfferingUser: IOfferingUser | undefined = undefined;
    pCourseCode: string | undefined = undefined;
    pResponse: boolean | undefined = undefined;
    pConsentForm: IConsentForm | undefined = undefined;
    pOffering: IOffering | undefined = undefined;

    updateUserConsent(newConsent: boolean) {
        this.updateConsentResponse(newConsent);
        UserService.sendConsent(newConsent);

        addEventsToQueue([{
            name: "Consent Altered",
            description: "Response is now: " + (newConsent == true ? "Accepted" : "Declined"),
            icon: "cached"
        }]);

        this.$router.push({ "name": "answer" });
    }

    updateCourseUser(user: IOfferingUser) {
        this.pOffering = user.offering;
        this.pCourseCode = user.offering.courseCode;
        this.pOfferingUser = user;
    }

    setConsentForm(consentForm: IConsentForm | undefined) {
        if (consentForm !== undefined && consentForm.content) {
            this.pConsentForm = consentForm;
        } else {
            this.pConsentForm = undefined;
        }
    }

    updateConsentResponse(newResponse: boolean | undefined) {
        this.pResponse = newResponse;
    }

    @Lifecycle
    created() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateCourseUser);
        Fetcher.get(UserService.getConsentForm)
            .on(this.setConsentForm);

        // Don't subscribe to this queue; since we are the ones managing it
        UserService.getUserConsentFormResponse()
            .then(x => this.updateConsentResponse(x));
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateCourseUser);
        Fetcher.get(UserService.getConsentForm)
            .off(this.setConsentForm);
    }

    get courseCode() {
        return this.pCourseCode;
    }
    get consentForm() {
        return this.pConsentForm;
    }
    get response() {
        return this.pResponse;
    }
    get offering() {
        return this.pOffering;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/ConsentFormWrapper.vue